import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import DragHandleVerticalIcon from '@atlaskit/icon/core/migration/drag-handle-vertical--drag-handler';
import { token } from '@atlaskit/tokens';

type BeforeTabProps = {
	elementBefore?: ReactNode | undefined;
	isDraggable: boolean;
	draggableRef?: React.RefObject<HTMLDivElement>;
};

const BeforeTab = ({ elementBefore, isDraggable, draggableRef }: BeforeTabProps) =>
	elementBefore ? (
		<>
			<ElementBeforeContainer>{elementBefore}</ElementBeforeContainer>
			{isDraggable && (
				<DragHandleContainer ref={draggableRef}>
					<DragHandleVerticalIcon label="" LEGACY_size="small" />
				</DragHandleContainer>
			)}
		</>
	) : undefined;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ElementBeforeContainer = styled.span({
	width: token('space.200'),
	height: token('space.200'),
	display: 'var(--display-icon-before, flex)',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DragHandleContainer = styled.span({
	cursor: 'grab',
	width: token('space.200'),
	height: token('space.200'),
	display: 'var(--display-drag-handle, none)',
});

export default BeforeTab;
